import { PersonType } from '@/types/api';
import CandidateNotesCard, { CandidateNotesCardType } from '../CandidateNotesCard';
import CandidateNotesSidebar, {
  CandidateNotesSidebarComponentType,
} from '../CandidateNotesSidebar';

type Props = CandidateNotesSidebarComponentType &
  Pick<CandidateNotesCardType, 'onAddNewNote' | 'onChangeCandidateField'> & {
    candidate: PersonType;
    autoScrollTopic?: string;
    onAutoScroll?: () => void;
  };

const CandidateNotesPageContent = ({
  candidate,
  candidateStages,
  onOpenModal,
  onAddNewNote,
  onChangeCandidateField,
  autoScrollTopic,
  onAutoScroll,
}: Props): JSX.Element => {
  return (
    <div className="tw-flex">
      <CandidateNotesSidebar candidateStages={candidateStages} onOpenModal={onOpenModal} />
      <div className="tw-w-full">
        {candidateStages.map((stage) => {
          return (
            <div key={stage.id}>
              {stage.topics.map((topic) => {
                return (
                  <CandidateNotesCard
                    onChangeCandidateField={onChangeCandidateField}
                    candidate={candidate}
                    onAddNewNote={onAddNewNote}
                    key={topic.id}
                    autoScroll={topic.id === autoScrollTopic}
                    onAutoScroll={onAutoScroll}
                    {...topic}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CandidateNotesPageContent;
